import { useState } from "react";
import { Icon } from "@monta/design-system";
import clsx from "clsx";
import styles from "./subMenuMobile.module.scss";
import SubMenuSpecial from "./special/SubMenuSpecial";
import MenuItem from "../../menuItem/MenuItem";
import { generatPropsTagA } from "../../menuItem/generatPropsTagA";
import type { IMenu } from "../../../../../constants";

interface SubMenuMobileProps {
  menuItem: IMenu;
  onCloseDrawer?: () => void;
}

const SubMenuMobile = (props: SubMenuMobileProps) => {
  const { menuItem, onCloseDrawer } = props;
  const [openSubMenu, setOpenSubMenu] = useState(false);
  const propTagA = generatPropsTagA(menuItem, undefined, onCloseDrawer);

  return (
    <li className={styles["sub-menu"]} id="SubMenuMobile">
      <div>
        <div
          className={clsx(
            styles["sub-menu__title"],
            openSubMenu && styles["sub-menu__title--active"],
          )}
        >
          {propTagA.href ? (
            <a {...propTagA}>{menuItem.title}</a>
          ) : (
            <label>{menuItem.title}</label>
          )}
          <Icon
            onClick={() => menuItem?.childs && setOpenSubMenu(!openSubMenu)}
            icon={"mi-Arrow-Left"}
          />
        </div>
      </div>

      <div
        className={clsx(
          styles["collaps"],
          openSubMenu && styles["collaps--show"],
        )}
      >
        <div>
          {menuItem.showTypeID === 1 ? (
            <SubMenuSpecial
              items={menuItem?.childs?.linkList}
              onCloseDrawer={() => onCloseDrawer && onCloseDrawer()}
            />
          ) : (
            menuItem?.childs?.linkList.map((subMenu) => {
              return (
                <div key={subMenu.linkID}>
                  <div className={styles["title"]}>{subMenu.title}</div>
                  {subMenu?.childs?.linkList.map((subMenuItem) => {
                    return (
                      <div
                        key={subMenuItem.linkID}
                        className={styles["sub-menu"]}
                      >
                        <MenuItem
                          menuItem={subMenuItem}
                          className={styles.subMenuItems}
                          onCloseDrawer={() => onCloseDrawer && onCloseDrawer()}
                        />
                      </div>
                    );
                  })}
                </div>
              );
            })
          )}
        </div>
      </div>
    </li>
  );
};

export default SubMenuMobile;
